import { useState } from "react";

const defaultProps = {
  onSubmit: () => {},
};

const InputReadMassiveOrders = (props) => {
  const { onSubmit } = { ...defaultProps, ...props };

  const [inputValues, setInputValues] = useState([]);
  const [textareaValue, setTextareaValue] = useState("");

  const onChangeBulkGuide = (e) => {
    const value = e?.target?.value || "";

    const newValues = value
      .split(/[\r?\n,]+/)
      .map((val) => val.trim())
      .filter(Boolean);

    setInputValues(newValues);
    setTextareaValue(value);
  };

  const handleClickSearch = () => {
    onSubmit?.(inputValues);
    setTextareaValue("");
    setInputValues([]);
  };

  return (
    <div className="row">
      <div className="col">
        <textarea
          className="form-control form-control-user"
          value={textareaValue}
          placeholder={
            "Ingrese las guías separadas por coma o por salto de línea."
          }
          rows={1}
          style={{ resize: "none", width: "100%", minWidth: "500px" }}
          onChange={onChangeBulkGuide}
        />
      </div>
      <div className="col">
        {inputValues?.length > 0 && (
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleClickSearch}
          >
            Buscar
          </button>
        )}
      </div>
    </div>
  );
};

export default InputReadMassiveOrders;
